import { handleEndDate, getQueryVariables } from '@/resources/utils'

const {
  period: { start, end },
  pagination: { page, pageSize },
} = getQueryVariables()

export const filtersDefault = {
  search: undefined,
  orderStatus: [],
  ratings: [],
  courierEmail: '',
  paymentMethods: [],
  deliveryTypes: [],
  period: { start: start.toISOString(), end: end.toISOString() },
  page,
  pageSize,
  hasMoreOrders: true,
}

const setSearch = (state, searchValue) => {
  const hasValue = searchValue?.value?.length > 0
  return { ...state, search: hasValue ? searchValue : undefined }
}

const setCourierEmail = (state, value) => {
  return { ...state, courierEmail: value }
}

const setStatus = (state, value) => {
  return { ...state, orderStatus: value }
}

const setRating = (state, value) => {
  return { ...state, ratings: value }
}

const setPaymentMethods = (state, value) => {
  return { ...state, paymentMethods: value }
}

const setDeliveryTypes = (state, value) => {
  return { ...state, deliveryTypes: value }
}

const clearFilters = () => {
  return filtersDefault
}

const setPeriod = (state, value) => {
  return {
    ...state,
    period: {
      start: value[0].toISOString(),
      end: handleEndDate(value[1]).toISOString(),
    },
  }
}

const updateMultipleFilters = (state, value) => {
  return {
    ...state,
    ...value,
  }
}

const setPage = (state, value) => {
  return { ...state, page: value }
}

const setHasMoreOrders = (state, value) => {
  return { ...state, hasMoreOrders: value }
}

const setPageSize = (state, value) => {
  return { ...state, pageSize: value }
}

const filterActions = {
  SEARCH: setSearch,
  COURIER_EMAIL: setCourierEmail,
  STATUS: setStatus,
  RATINGS: setRating,
  PAYMENT_METHODS: setPaymentMethods,
  DELIVERY_TYPES: setDeliveryTypes,
  CLEAR_FILTERS: clearFilters,
  PERIOD: setPeriod,
  PAGE: setPage,
  PAGE_SIZE: setPageSize,
  HAS_MORE_ORDERS: setHasMoreOrders,
  UPDATE_MULTIPLE: updateMultipleFilters,
}

const filtersReducer = (state, action) => {
  return filterActions[action.type](
    {
      ...state,
      page: action.resetPage ? page : state.page,
    },
    action.value
  )
}

export default filtersReducer
